import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnInit, Input } from '@angular/core';
import { PaymentDerivedStatus, RecurringOccuranceType } from '@fitness-force/enum';
import { CurrencyformatPipe } from '@fitness-force/pipes/currency';
import { TranslateService } from '@ngx-translate/core';
import { InvoiceOccurance } from 'libs/models/src/lib/subscription/payment-timeline';
import { ToastMessageService } from '@fitness-force/api';
import { BadgeModule } from 'primeng/badge';
import { StyleClassModule } from 'primeng/styleclass';
import { TagModule } from 'primeng/tag';
import { TooltipModule } from 'primeng/tooltip';
import { BehaviorSubject } from 'rxjs';

@Component({
  selector: 'invoice-payment-amount',
  templateUrl: './invoice-payment-amount.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [ToastMessageService],
  standalone: true,
  imports: [
    CommonModule,
    StyleClassModule,
    TooltipModule,
    BadgeModule,
    TagModule,
    StyleClassModule,
    CurrencyformatPipe
  ]
})
export class InvoicePaymentAmountComponent implements OnInit {
  @Input() columnData = new BehaviorSubject(null);
  @Input() additionData = new BehaviorSubject(null);
  constructor(public translate: TranslateService) { }

  ngOnInit(): void {
  }

  public get paymentStatus()
  {
    return PaymentDerivedStatus;
  }

  public get recurringOccuranceType()
  {
    return RecurringOccuranceType;
  }

  getTooltipMessage(OcurenctType:InvoiceOccurance)
  {
    let message:string="";
    var data = RecurringOccuranceType[OcurenctType.occurance_type.toString() as keyof typeof RecurringOccuranceType]
    switch (data) {
      case RecurringOccuranceType.Deposit:
        this.translate.get('SUBSCRIPTIONS.PAYMENT_TIMELINE.ERROR_MSG')
        .subscribe((translations: any) => {
          message = translations;
        });
        break;
      case RecurringOccuranceType.EndProrata:
        this.translate.get('SUBSCRIPTIONS.PAYMENT_TIMELINE.ERROR_MSG')
        .subscribe((translations: any) => {
          message = translations;
        });
        break;
      case RecurringOccuranceType.Freeze:
        this.translate.get('SUBSCRIPTIONS.PAYMENT_TIMELINE.ERROR_MSG')
        .subscribe((translations: any) => {
          message = translations;
        });
        break;
      case RecurringOccuranceType.InitialProRata:
        this.translate.get('SUBSCRIPTIONS.PAYMENT_TIMELINE.ERROR_MSG')
        .subscribe((translations: any) => {
          message = translations;
        });
        
        break;
      case RecurringOccuranceType.MiddCycleAddon:
        this.translate.get('SUBSCRIPTIONS.PAYMENT_TIMELINE.MID_CYCLE_ADDON_MSG')
        .subscribe((translations: any) => {
          message = translations;
        });
        break;
      case RecurringOccuranceType.MiddCycleDiscount:
        this.translate.get('SUBSCRIPTIONS.PAYMENT_TIMELINE.MID_CYCLE_DIS_MSG')
        .subscribe((translations: any) => {
          message = translations;
        });
        break;
      case RecurringOccuranceType.Recurring:
        this.translate.get('SUBSCRIPTIONS.PAYMENT_TIMELINE.ERROR_MSG')
        .subscribe((translations: any) => {
          message = translations;
        });
        break;
      }
    return message;
  }

  isSuccessfulPayment(timeline: InvoiceOccurance): boolean {
    return timeline.payment_status === this.paymentStatus.Successfull ||
      timeline.payment_status!.toString() === this.paymentStatus[this.paymentStatus.Successfull];
  }

  isfailedPayment(timeline: InvoiceOccurance): boolean {
    return timeline.payment_status === this.paymentStatus.Failed ||
      timeline.payment_status!.toString() === this.paymentStatus[this.paymentStatus.Failed];
  }

  isOccurenceDiscount(timeline: InvoiceOccurance): boolean {
    return timeline.occurance_type === this.recurringOccuranceType.MiddCycleDiscount ||
      timeline.occurance_type!.toString() === this.recurringOccuranceType[this.recurringOccuranceType.MiddCycleDiscount];
  }

  shouldShowIcon(timeline: any): boolean {
    let result:boolean=false;
    var data = RecurringOccuranceType[timeline.occurance_type.toString() as keyof typeof RecurringOccuranceType]
    switch (data) {
      case RecurringOccuranceType.Deposit:
       result= true;
        break;
      case RecurringOccuranceType.EndProrata:
        result= false;

        break;
      case RecurringOccuranceType.Freeze:
        result= true;
        break;
      case RecurringOccuranceType.InitialProRata:
        result= false;
        break;
      case RecurringOccuranceType.MiddCycleAddon:
        result= true;
        break;
      case RecurringOccuranceType.MiddCycleDiscount:
        result= true;
        break;
      case RecurringOccuranceType.Recurring:
        result= false;
        break;
      }
    return result;
  }

  showBadgeInStatusNoneCase(OcurenctType:any)
  {
    let show:boolean=false;
    var data = RecurringOccuranceType[OcurenctType.toString() as keyof typeof RecurringOccuranceType]
    switch (data) {
      case RecurringOccuranceType.Deposit:
        show=false;
        break;
      case RecurringOccuranceType.EndProrata:
        show=false;
        break;
      case RecurringOccuranceType.Freeze:
        show=true;
        break;
      case RecurringOccuranceType.InitialProRata:
        show=false;
        break;
      case RecurringOccuranceType.MiddCycleAddon:
        show=true;
        break;
      case RecurringOccuranceType.MiddCycleDiscount:
        show=true;
        break;
      case RecurringOccuranceType.Recurring:
        show=false;
        break;
      }
    return show;
  }

}